<div class="credit-consent-required-dialog">
  <h3 mat-dialog-title>Privacy consent required</h3>
  <mat-dialog-content class="pt-2">
    <div class="row separator-bottom">
      <div class="col-12">
        <message-box type="warn">
          The credit flow can only run once every individual has a valid, signed privacy consent. The following individual(s) need attention.
        </message-box>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table mat-table [dataSource]="rows" class="consent-table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Individual</th>
            <td mat-cell *matCellDef="let row">{{ row.name }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Consent status</th>
            <td mat-cell *matCellDef="let row">
              <privacy-consent-status-chip
                [status]="row.consentStatusLabel"
                [styleKey]="statusStyleKey(row)"></privacy-consent-status-chip>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="action-cell">
              <button mat-flat-button class="active resend-button" [disabled]="row.sending || row.sent" (click)="send(row)">
                {{ actionLabel(row) }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="width-100 pl-lt-md-3 pr-lt-md-3"
         fxLayoutGap="10px"
         fxLayout="row"
         fxLayout.lt-md="column"
         fxLayoutAlign="end center"
         fxLayoutAlign.lt-md="center start">
      <button mat-flat-button class="w-lt-md-100" color="primary" (click)="close()">Close</button>
    </div>
  </mat-dialog-actions>
</div>
